module.exports = __webpack_public_path__ + "img/klinik-bg.c3c83893.svg";